import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditorComponent } from './editor.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { FormsModule } from '@angular/forms';

const PIPES = []!;

const ANGULAR_MATERIAL_MODULES = []!;

const CORE_MODULES = [CommonModule, FormsModule];

const COMPONENTS = [EditorComponent];

@NgModule({
  declarations: [...COMPONENTS, ...PIPES],
  imports: [...CORE_MODULES, ...ANGULAR_MATERIAL_MODULES, CKEditorModule],
  exports: [...COMPONENTS]
})
export class EditorModule { }
